export const getQueryParamsWithCustomQueryObj = (
  obj:
    | string
    | string[][]
    | Record<string, string>
    | URLSearchParams
    | undefined
) => {
  const queryString = new URLSearchParams(obj ?? {}).toString();
  return queryString;
};
